export default __webpack_public_path__ + "static/media/mp3-icon.e38ca81c.jpg";